import client from './client';

export const listBatches = () => client.get('/batches').then((r) => r.data);
export const updateBatch = (id, payload) => client.patch(`/batches/${id}`, payload).then((r) => r.data);
export const removeBatch = (id) => client.delete(`/batches/${id}`).then((r) => r.data);
